<template>
  <mtd-dropdown style="padding: 0 5px" trigger="click" placement="bottom">
    <div class="lang">
      <mtd-icon name="mtdicon-globe" class="lang-icon"></mtd-icon>
      <mtd-button type="text-primary" class="lang-text-btn">
        {{ langStr }}
      </mtd-button>
      <mtd-icon name="mtdicon-down-thick" class="lang-arrow"></mtd-icon>
    </div>
    <template #dropdown>
      <mtd-dropdown-menu>
        <mtd-dropdown-menu-item
          v-for="item in langConfig.langList"
          :key="item.key"
          :command="item.value"
          @click="changeLang(item)"
        >
          <div
            :class="{ selected: item.value === lang, 'dropdown-item': true }"
          >
            <span class="label">{{ item.label }}</span>
            <mtd-icon
              v-if="item.value === lang"
              name="mtdicon-check"
              class="el-icon-check"
            ></mtd-icon>
          </div>
        </mtd-dropdown-menu-item>
      </mtd-dropdown-menu>
    </template>
  </mtd-dropdown>
</template>
<script>
import { getCookie } from "@osgfe/tools";

const reportLx = (...args) => {
  if (window.LXAnalytics) {
    window.LXAnalytics(...args);
  }
};

const langConfig = {
  lang: "zh",
  langList: [
    {
      label: "中文（简体）",
      value: "zh",
    },
    {
      label: "English",
      value: "en",
    },
    {
      label: "بالعربية",
      value: "ar",
    },
  ],
};

export default {
  name: "McLang",
  props: {
    lxConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lang: langConfig.lang,
      langConfig: langConfig,
    };
  },
  computed: {
    langStr() {
      return this.langConfig.langList.find((item) => item.value === this.lang)
        .label;
    },
  },
  mounted() {
    this.lang = this.$i18nClient.getCurrentLocale();
    console.log("ang:", this.lang);
    reportLx(
      "moduleView",
      this.lxConfig?.initLangBid,
      {
        mis_id: getCookie("msid") || "999",
        locale: this.lang,
      },
      {
        cid: this.lxConfig?.cid,
      }
    );
  },
  methods: {
    changeLang(item) {
      reportLx(
        "moduleClick",
        this.lxConfig?.changeLangBid,
        {
          mis_id: getCookie("msid") || "999",
          locale: item.value,
        },
        {
          cid: this.lxConfig?.cid,
        }
      );
      this.$i18nClient.changeLanguage(item.value, (err) => {
        if (err) {
          console.error("语言切换失败");
          return;
        } else {
          console.log("reload");
          window.location.reload();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lang {
  color: #111925;
  display: flex;
  align-items: center;
  margin-inline-end: 24px;
  .lang-text-btn {
    color: #111925;
    margin: 0 4px;
    padding: 0;
    border: none;
  }
  .lang-icon {
    vertical-align: middle;
    font-size: 20px;
  }

  .lang-arrow {
    vertical-align: middle;
    font-size: 18px;
  }
}

.selected {
  color: #00b85c;
  font-weight: 700;
}
</style>
